import { motion } from "framer-motion";

/* Calm, formal scroll-reveal — fades up once, never bouncy. */
export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);
